<template>
  <div class="qa-item-thread">
    <QuestionAnswerItemThreadNavigation :mnemo="mnemo" :question="question" />

    <AppCard elevation="0">
      <v-card-text class="qa-item-thread__content">
        <QuestionAnswerItemThreadQuestion :mnemo="mnemo" />

        <div v-if="hasAnswers" class="qa-item-thread__answers">
          <div class="qa-item-thread__answers-title">
            {{ $t('project.question-answer.QuestionAnswerItemThread.answers', { nbAnswers: answersCount }) }}
          </div>

          <v-timeline align="start" density="compact">
            <QuestionAnswerItemThreadAnswer
              v-for="answer in question.answers"
              :key="`answer-${answer.id}`"
              :answer="answer"
            />
          </v-timeline>
        </div>

        <div class="qa-item-thread__add-answer">
          <QuestionAnswerItemThreadAnswerAdd
            v-if="canAddAnswer"
            ref="answerAddForm"
            :mnemo="mnemo"
          />
        </div>
      </v-card-text>
    </AppCard>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppCard from '@/common/AppCard.vue'

import QuestionAnswerItemThreadAnswer from './QuestionAnswerItemThreadAnswer.vue'
import QuestionAnswerItemThreadAnswerAdd from './QuestionAnswerItemThreadAnswerAdd.vue'
import QuestionAnswerItemThreadNavigation from './QuestionAnswerItemThreadNavigation.vue'
import QuestionAnswerItemThreadQuestion from './QuestionAnswerItemThreadQuestion.vue'

export default {
  name: 'QuestionAnswerItemThread',
  components: {
    AppCard,
    QuestionAnswerItemThreadAnswer,
    QuestionAnswerItemThreadAnswerAdd,
    QuestionAnswerItemThreadNavigation,
    QuestionAnswerItemThreadQuestion,
  },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('questionAnswer', ['question', 'markQuestionAsResolvedPending']),
    ...mapState('room', ['currentRoom']),
    answersCount () {
      return Array.isArray(this.question?.answers) ? this.question.answers.length : 0
    },
    hasAnswers () {
      return this.answersCount > 0
    },
    canAddAnswer () {
      return this.question?.status !== 'validated'
    },
  },
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";

.qa-item-thread {
  &__content {
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      padding-left: 90px;
    }
  }

  &__navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  }

  &__answers {
    color: #333333;
    margin-top: 16px;

    &-title {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 24px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgb(var(--v-theme-grey-300));
    }
  }

  &__actions {
    margin-top: 20px;
    text-align: right;

    button:not(:last-child) {
      margin-right: 16px;
    }
  }

  &__add-answer {
    margin-top: 24px;
  }
  .v-timeline:before {
    display: none;
  }
}
</style>
